import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container py-1" }
const _hoisted_2 = { class: "border-[10px] rounded-[1.8rem] flex items-center justify-center flex-col px-[2.1rem] py-[2.1rem] border-jm_orange bg-jm_dark_green max-w-[92%] sm:max-w-[97%] mx-auto" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "text-[24px] font-bold uppercase text-center whitespace-nowrap leading-[2.15rem] max-w-md text-jm_white" }
const _hoisted_5 = { class: "mt-[0.7rem] mb-[0.3rem] text-[16px] max-w-80 leading-[1.17rem] text-center text-jm_white whitespace-pre-line" }
const _hoisted_6 = { class: "flex sm:flex-row items-center justify-center mt-6 gap-[0.66rem]" }

import { useGlobalStore } from "../stores/global";
import { useGameTracking } from "@/composables/useGameTracking";
import logo from "@/assets/images/misc/logo_jaegermeister_white.svg";


export default /*@__PURE__*/_defineComponent({
  __name: 'AgeSelector',
  setup(__props) {

const globalStore = useGlobalStore();
const { kpiTracker, session } = useGameTracking();

const handleClick = async (answer: string) => {
  if (answer === "yes") {
    globalStore.confirmAgeCheck(true);
    kpiTracker.setConfirmedConsent(true);
    
    // Set progress to 1 (age_gate_clicked) when user clicks yes
    kpiTracker.setProgress(1);
    
    // Update session with progress "age_gate_clicked"
    console.log("[AgeSelector] Updating session with progress 'age_gate_clicked'");
    try {
      await session.updateSessionProgress(kpiTracker.getKpiData(), { step: "age_gate_clicked" });
      console.log("[AgeSelector] Session update completed");
    } catch (error) {
      console.error("[AgeSelector] Error updating session:", error);
    }

    globalStore.changeStep("termsAcceptance");
  } else {
    // For "no", don't track age_gate_clicked - just go to ageCheckFailed
    // The ageCheckFailed step will be tracked automatically by the watch in App.vue
    globalStore.changeStep("ageCheckFailed");
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        src: _unref(logo),
        alt: "logo",
        class: "w-[95px] mb-[1rem] mt-[0.15rem] slide mx-auto"
      }, null, 8, _hoisted_3),
      _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t("age_check.message")), 1),
      _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t("age_check.enter_birthday")), 1),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (handleClick('yes'))),
          type: "button",
          class: "px-[3rem] py-[0.45rem] text-[16px] sm:text-sm font-bold bg-jm_white rounded-[0.7rem] border border-gray-200 uppercase text-jm_dark_green"
        }, _toDisplayString(_ctx.$t("age_check.confirm_button")), 1),
        _createElementVNode("button", {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (handleClick('no'))),
          type: "button",
          class: "px-[3rem] py-[0.45rem] text-[16px] sm:text-sm font-bold bg-jm_white rounded-[0.7rem] border border-gray-200 uppercase text-jm_dark_green"
        }, _toDisplayString(_ctx.$t("age_check.reject_button")), 1)
      ])
    ])
  ]))
}
}

})